import { BlankState } from '@domain-group/suit-theme'

import BlankStateImage from './assets/no-orders.svg'

const QuotesBlankState = () => (
  <BlankState boxProps={{ marginBottom: 'large' }} imageUrl={BlankStateImage}>
    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Title>No Quotes</BlankState.Title>

    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Paragraph>
      No campaign quotes to display. Try changing your filters if you have any selected. Quotes will appear here once
      you have created a campaign and have added a quote.
      {/*
     // @ts-expect-error TS2339 */}
    </BlankState.Paragraph>
  </BlankState>
)

export default QuotesBlankState
